<!--
  - Copyright (c) 2021 LNBIG.com
  - All rights reserved.
  -->

<template>
  <v-container
      fluid
  >
    <v-row>
      <v-col cols="12" class="text-start mb-16 mt-5" v-if="channelPoint">
        <p class="text-h5">The channel was opened<br><span class="text-h6">Channel point:</span></p>
        <p class="text-h6 text-truncate text-no-wrap">
          <a :href="'https://mempool.space/tx/' + channelPoint.tx" target="_blank" class="text-decoration-none">{{channelPoint.tx + ':' + channelPoint.index}}</a>
        </p>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-avatar
            color="green"
            size="150"
        >
          <v-icon
              color="white"
              size="100"
          >
            done
          </v-icon>
        </v-avatar>
      </v-col>
      <v-col
          class="my-4 text-center"
          cols="12"
      >
        <v-btn
            color="primary"
            @click="$emit('restart-process')"
        >
          OK
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "FinalGoodStatus",
  props: {
    channelPoint: {
      type: Object,
      required: true
    },
  },
}
</script>

<style scoped>

</style>
